import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const Yaleo = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function Yaleo({ colored, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M18.2581 1H5.72093C4.21395 1 3 2.17712 3 3.63838V15.7952C3 17.2565 4.21395 18.4336 5.72093 18.4336H12V16.9114H5.72093C5.09302 16.9114 4.5907 16.4244 4.5907 15.8155V3.63838C4.5907 3.02952 5.09302 2.54244 5.72093 2.54244H18.2581C18.886 2.54244 19.3884 3.02952 19.3884 3.63838V8.32657C19.3884 9.11808 19.1581 9.8893 18.7186 10.559L15.1186 16.2214L10.9842 9.73063C10.8389 9.50251 10.5385 9.43129 10.3062 9.56988L9.80507 9.86893C9.56295 10.0134 9.48811 10.3294 9.63969 10.5671L14.1767 17.6827L11.5856 21.7541C11.4343 21.9918 11.5092 22.3075 11.7512 22.4519L12.2531 22.7514C12.4852 22.8899 12.7854 22.8189 12.9308 22.591L20.0791 11.3911C20.686 10.4779 21 9.42251 21 8.32657V3.63838C20.9791 2.19742 19.7651 1 18.2581 1Z'
          fill={colored ? 'transparent' : color}
        />
        {/* colored */}
        <path
          d='M18.3012 1H5.69885C4.21102 1 3 2.16914 3 3.60781V15.7974C3 17.2361 4.21102 18.4052 5.69885 18.4052H11.5C11.7761 18.4052 12 18.1813 12 17.9052V17.4442C12 17.1681 11.7761 16.9442 11.5 16.9442H5.69885C5.04336 16.9442 4.51089 16.4294 4.51089 15.7974V3.60781C4.51089 2.97584 5.04336 2.46097 5.69885 2.46097H18.3012C18.9566 2.46097 19.4891 2.97584 19.4891 3.60781V8.30669C19.4891 9.11152 19.2546 9.89219 18.8048 10.5743L15.1506 16.2937L10.9597 9.7287C10.8143 9.50086 10.5141 9.42986 10.282 9.56841L9.85506 9.82327C9.6129 9.96782 9.53814 10.2839 9.6899 10.5216L14.2625 17.684L11.6336 21.798C11.4817 22.0357 11.5564 22.3519 11.7986 22.4965L12.2256 22.7514C12.4576 22.8899 12.7577 22.819 12.9032 22.5913L20.085 11.3513C20.6828 10.4424 21 9.39033 21 8.30669V3.60781C21 2.16914 19.789 1 18.2992 1H18.3012Z'
          fill={colored ? 'url(#paint0_linear_1041_302)' : 'transparent'}
        />
        <defs>
          <linearGradient id='paint0_linear_1041_302' x1='21.1366' y1='22.7975' x2='3.0685' y2='0.0497959' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#5C0F8B' />
            <stop offset='1' stopColor='#00B5E2' />
          </linearGradient>
        </defs>
      </>
    ),
    [colored],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'yaleo-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Yaleo;
